<template>
  <div class="filter-bar ui basic segment grid">
    <div class="ui form">
      <div class="inline field">
        <h6 class="heading-small text-muted mb-4">Search</h6>
        <div class="input-group mb-3">
          <input type="text" class="form-control" :placeholder="placeholder" @keyup.enter="doFilter"
            v-model="filterText">
          <div class="input-group-append">
            <base-dropdown v-model="searchFilter">
              <base-button slot="title" type="secondary"
                class="btn-outline-primary dropdown-toggle dropdown-toggle-split"
                style="border-top-left-radius: 0px;border-bottom-left-radius: 0px; height: 35px!important;" />
              <a class="dropdown-item" @click.prevent="changeSearchFilter('name')" v-if="(currentProfile != 'gift_certificates' && currentProfile != 'add_on_charges')">Name</a>
              <a class="dropdown-item" @click.prevent="changeSearchFilter('user_name')" v-if="(currentProfile == 'users')"> Username </a>
              <a class="dropdown-item" @click.prevent="changeSearchFilter('hcm_id')" v-if="(currentProfile == 'users')"> HCM ID </a>
              <a class="dropdown-item" @click.prevent="changeSearchFilter('company')" v-if="(currentProfile == 'add_on_charges')">Company</a>
              <a class="dropdown-item" @click.prevent="changeSearchFilter('supplier')" v-if="(currentProfile == 'add_on_charges')">Supplier</a>
              <a class="dropdown-item" @click.prevent="changeSearchFilter('name')" v-if="(currentProfile == 'add_on_charges')">Description</a>
              <a class="dropdown-item" @click.prevent="changeSearchFilter('aoc_number')" v-if="(currentProfile == 'add_on_charges')">Add On Number</a>
              <a class="dropdown-item" v-if="(currentProfile != 'users' && currentProfile != 'add_on_charges')"
                @click.prevent="changeSearchFilter('code')">Code</a>
              <a class="dropdown-item" v-if="(currentProfile == 'sites')" @click.prevent="changeSearchFilter('refcode')">Reference Code</a>
              <a class="dropdown-item" @click.prevent="changeSearchFilter('created_by')" v-if="(currentProfile == 'brands')"> Created By </a>
              <a class="dropdown-item" @click.prevent="changeSearchFilter('updated_by')" v-if="(currentProfile == 'brands')"> Updated By </a>
              <!-- <a class="dropdown-item" v-if="(currentProfile == 'reasons')" @click.prevent="changeSearchFilter('reason_type')">Reason Type</a> -->
              </base-dropdown>
          </div>
        </div>

        <base-input v-if="currentProfile == 'brands'" label="Brands">
          <a-select mode="multiple" style="width: 100%" placeholder="Select Brands" :filter-option="filterOption" @search="fetchBrands" @focus="fetchBrands" @change="handleBrandsChange" :value="selectedBrands" :allowClear="true">
            <a-select-option v-for="b in brands" :key="String(b.id)" :value="String(b.id)"> {{ b.name }} </a-select-option>
          </a-select>
        </base-input>

        <base-input v-if="currentProfile == 'brands'" label="Brand Owner">
          <a-auto-complete style="width: 100%" placeholder="Select a Brand Owner" :filter-option="filterOption" v-model="brandOwnerInput" @select="selectBrandOwner" :value="selectedBrandOwner.label" @search="fetchCompanies" @focus="fetchCompanies" @change="handleCompanyChange" :allowClear="true">
            <template slot="dataSource">
              <a-select-option v-for="c in companies" :key="'companies' + c.id.toString()" :text="c.name"> {{ c.name }} </a-select-option>
            </template>
          </a-auto-complete>
        </base-input>

        <base-input v-if="currentProfile == 'brands'" label="Portfolio">
          <a-select v-model="portfolio" style="width: 100%" placeholder="Select Portfolio" :allowClear="true" show-search :filter-option="filterOption" @focus="fetchPortfolios" @change="handlePortfolioChange">
            <a-select-option v-for="p in portfolios" :key="p" :value="p"> {{ p }} </a-select-option>
          </a-select>
        </base-input>

        <base-input v-if="(currentProfile == 'add_on_charges')" label="Document Date"><br>
            <a-range-picker v-model="document_date" format="MM/DD/YYYY" :placeholder="['Start Date', 'End Date']" style="width:100%" @change="doFilter" />
        </base-input>

        <base-input v-if="(currentProfile == 'user_groups' || currentProfile == 'brands')" label="Created At Date">
          <a-range-picker v-model="created_date" format="MM/DD/YYYY" :placeholder="['Start Date', 'End Date']" style="width:100%" @change="doDateFilter" />
        </base-input>
        
        <base-input v-if="(currentProfile == 'user_groups' || currentProfile == 'brands')" label="Updated At Date">
          <a-range-picker v-model="updated_date" format="MM/DD/YYYY" :placeholder="['Start Date', 'End Date']" style="width:100%" @change="doDateFilter" />
        </base-input>

        <base-input v-if="(currentProfile == 'reason_types')" label="Operation">
          <select class="form-control" v-model="operation" @change="doFilter()" size="large">
            <option v-for="option in operationOptions" v-bind:value="option.key" v-bind:key="option.key">
              {{ option.value }}
            </option>
          </select>
        </base-input>

        <hr class="my-4" />
        <h6 class="heading-small text-muted mb-4">Filter by status</h6>
        <div v-if="(currentProfile == 'add_on_charges')">
          <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
            All
          </base-radio>
          <base-radio name="S" class="mb-3" v-model="filterStatus" value="S">
            Saved
          </base-radio>
          <base-radio name="P" class="mb-3" v-model="filterStatus" value="P">
            Posted
          </base-radio>
          <base-radio name="D" class="mb-3" v-model="filterStatus" value="D">
            Deleted
          </base-radio>
        </div>
        <div v-else-if="currentProfile == 'gift_certificates'">
          <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
            All
          </base-radio>
          <base-radio name="C" class="mb-3" v-model="filterStatus" value="C">
            Created
          </base-radio>
          <base-radio name="A" class="mb-3" v-model="filterStatus" value="A">
            Activated
          </base-radio>
          <base-radio name="I" class="mb-3" v-model="filterStatus" value="I">
            Inactive
          </base-radio>
          <base-radio name="U" class="mb-3" v-model="filterStatus" value="U">
            Used
          </base-radio>
          <base-radio name="S" class="mb-3" v-model="filterStatus" value="S">
            Sold
          </base-radio>
          <base-radio name="V" class="mb-3" v-model="filterStatus" value="V">
            Voided
          </base-radio>
        </div>
        <div v-else>
          <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
            All
          </base-radio>
          <base-radio name="A" class="mb-3" v-model="filterStatus" value="A">
            Active
          </base-radio>
          <base-radio name="I" class="mb-3" v-model="filterStatus" value="I">
            Inactive
          </base-radio>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HTTPRequest from '../controllers/httpRequest'
  import Autocomplete from 'vuejs-auto-complete'
  import { mapState, mapActions } from 'vuex'
  import moment from 'moment';

  export default {
    components: {
      Autocomplete,
    },
    computed: {
      ...mapState(['currentProfile', 'endPoint', 'serverType']),
    },
    data: function () {
      return {
        filterText: '',
        document_date: [moment().subtract(3,'months'), moment().endOf('day')],
        created_date: [],
        updated_date: [],
        searchFilter: "name",
        placeholder: "Search by Name",
        filterStatus: '0',
        operation: '',
        operationOptions: [
          { value: "ALL", key: ""},
          {value: "ABORT RECEIPT", key: "ABT"},
          {value: "ITEM DISCOUNT", key: "DSC"},
          {value: "LINE VOID", key: "LVD"},
          {value: "VOID RECEIPT", key: "VOI"},
          {value: "PRICE OVERRIDE", key: "OVD"},
          {value: "TRANSACTIONAL PRICE CHANGE", key: "PLC"},
          {value: "REPRINT OF RECEIPT", key: "PRN"},
          {value: "RETURN", key: "RET"},
          {value: "TAX CHANGE", key: "TAX"},
          {value: "BARCODE PRINTING", key: "BCD"},
          {value: "WITHDRAWAL", key: "WIT"},
          {value: "DEPOSIT", key: "DEP"}
        ],
        companies: [],
        brands: [],
        fetching: false,
        selectedBrandOwner: { key: '', label: '' },
        brandOwnerInput: '',
        selectedBrands: [],
        portfolios: [],
        portfolio: null,
        currentParams: {},
      }
    },
    mounted: async function () {
      this.placeholder = (this.currentProfile == 'gift_certificates') ? "Search by Code" : "Search by Name";
    },
    watch: {
      filterStatus: function () {
        // eslint-disable-next-line
        // console.log(this.filterStatus)
        // changeFilter(statusFilter, searchFilter, searchText)
        let filterText = this.filterText
        if(this.currentProfile == 'reason_types' && this.operation != ""){
          filterText = filterText + "&" + "operation_type=" + this.operation
        }

        //Add param [table list][optimization]
        filterText = filterText + "&" + "call_type=list"

        this.$emit('changeFilter', this.filterStatus, this.searchFilter, filterText, this.document_date)
      },
      document_date: function () {
        // eslint-disable-next-line
        // console.log(this.filterStatus)
        // changeFilter(statusFilter, searchFilter, searchText)
        let filterText = this.filterText
        if(this.currentProfile == 'reason_types' && this.operation != ""){
          filterText = filterText + "&" + "operation_type=" + this.operation
        }

        //Add param [table list][optimization]
        filterText = filterText + "&" + "call_type=list"

        this.$emit('changeFilter', this.filterStatus, this.searchFilter, filterText, this.document_date)
      },
      created_date: function () {
        this.buildAndUpdateParameters();
      },
      updated_date: function () {
        this.buildAndUpdateParameters();
      },
    },
    methods: {
      ...mapActions(['updateParameters']),
      changeSearchFilter(searchFilter) {
        this.searchFilter = searchFilter
        if (searchFilter == "operation_type") {
          this.placeholder = "Search by operation"
        } else {
          this.placeholder = "Search by " + searchFilter
        }
      },
      moment,
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      async fetchCompanies(value = '') {
        this.fetching = true;
        try {
          const companies = await HTTPRequest.getRequest(this.endPoint + 'companies/get_valid_companies?mode=all=' + value, null);
          this.companies = companies || [];
        } catch (error) {
          console.error('Error fetching companies:', error);
        } finally {
          this.fetching = false;
        }
      },
      async fetchBrands(value = '') {
        this.fetching = true;
        try {
          const brands = await HTTPRequest.getRequest(this.endPoint + 'brands/get_valid_brands?name=' + value, null);
          this.brands = brands || [];
        } catch (error) {
          console.error('Error fetching brands:', error);
        } finally {
          this.fetching = false;
        }
      },
      async fetchPortfolios() {
        if (this.portfolios.length > 0) return;
        this.fetching = true;
        try {
          const response = await HTTPRequest.getRequest(this.endPoint + 'brands/get_portfolios');
          this.portfolios = response.portfolios || [];
        } catch (error) {
          console.error('Error fetching portfolios:', error);
        } finally {
          this.fetching = false;
        }
      },
      selectBrandOwner(company, option) {
        const id = company.replace('companies', '');
        const label = option.data.attrs.text;
        this.selectedBrandOwner = { key: id, label };
        this.brandOwnerInput = label;
        this.buildAndUpdateParameters();
      },
      handleCompanyChange(value) {
        if (!value) {
          this.selectedBrandOwner = { key: '', label: '' };
          this.brandOwnerInput = '';
          this.buildAndUpdateParameters();
        }
      },
      handleBrandsChange(value) {
        this.selectedBrands = value;
        this.buildAndUpdateParameters();
      },
      handlePortfolioChange(value) {
        this.portfolio = value || '';
        this.buildAndUpdateParameters();
      },
      buildAndUpdateParameters() {
        const params = new URLSearchParams();

        if (this.filterText) {
          params.append(this.searchFilter, this.filterText);
        }

        if (this.currentProfile === 'brands' && this.selectedBrandOwner.key) {
          params.append('brand_owner_id', this.selectedBrandOwner.key);
        }

        if (this.currentProfile === 'brands' && this.selectedBrands.length > 0) {
          params.append('id', this.selectedBrands.join(','));
        }

        if (this.portfolio) {
          params.append('portfolio', this.portfolio);
        }

        if (this.created_date && this.created_date.length === 2) {
          params.append('created_from_date', this.moment(this.created_date[0]).format('YYYY-MM-DD'));
          params.append('created_to_date', this.moment(this.created_date[1]).format('YYYY-MM-DD'));
        }

        if (this.updated_date && this.updated_date.length === 2) {
          params.append('updated_from_date', this.moment(this.updated_date[0]).format('YYYY-MM-DD'));
          params.append('updated_to_date', this.moment(this.updated_date[1]).format('YYYY-MM-DD'));
        }

        if (this.currentProfile == 'reason_types' && this.operation != "") {
          params.append('operation_type', this.operation);
        }

        params.append('call_type', 'list');
        this.currentParams = Object.fromEntries(params);
        this.updateParameters(`?${params.toString()}`);

        let filterText = this.filterText;
        if (this.currentProfile == 'reason_types' && this.operation != "") {
          filterText = filterText + "&" + "operation_type=" + this.operation;
        }

        if (this.currentProfile === 'brands' && this.selectedBrandOwner.key) {
          filterText += "&brand_owner_id=" + this.selectedBrandOwner.key;
        }

        if (this.currentProfile === 'brands' && this.selectedBrands.length > 0) {
          filterText += "&id=" + this.selectedBrands.join(',');
        }

        if (this.portfolio) {
          filterText += "&portfolio=" + this.portfolio;
        }

        if (this.created_date && this.created_date.length === 2) {
          filterText += "&created_from_date=" + this.moment(this.created_date[0]).format('YYYY-MM-DD');
          filterText += "&created_to_date=" + this.moment(this.created_date[1]).format('YYYY-MM-DD');
        }

        if (this.updated_date && this.updated_date.length === 2) {
          filterText += "&updated_from_date=" + this.moment(this.updated_date[0]).format('YYYY-MM-DD');
          filterText += "&updated_to_date=" + this.moment(this.updated_date[1]).format('YYYY-MM-DD');
        }

        filterText = filterText + "&" + "call_type=list";

        this.$emit('changeFilter', this.filterStatus, this.searchFilter, filterText, this.document_date);
      },
      doFilter() {
        this.buildAndUpdateParameters();
      },
      doDateFilter() {
        this.buildAndUpdateParameters();
      }
    }
  }
</script>
